import React, { useState, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, DeleteChildDialog, Icon, Input, Layout, Password, Toast, Dialog } from "@app/components";
import {
  Error,
  EmptyContainer,
  DefaultMessage
} from "@app/components/commonStyles";
import { useParams, useLocation } from 'react-router-dom'
import { emailPattern, gradesList, subjectOptions, ALPHA_NUMERIC, USERNAME_CHAR_COUNT } from "@app/utils";
import { faEye, faEyeSlash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AddButtonContainer, ButtonContainer, ActionsHolder, StudentDetailsWrapper, StudentDetailWrapper, StudentTableColumn, StudentTableContent, StudentTableContentHolder, StudentTableHeader, StudentTableWrapper, StudentsTableWrapper } from "./educator-component";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import RemoveIcon from "@app/components/icon/icons/remove-icon";
import { AuthContext } from "@app/providers";
import { getClassroom, deleteStudent, addStudent, validateEmail, resetStudentPassword, showStudentPassword } from "@app/services";
import { useHistory } from "react-router-dom";
import { GoogleSVG, AddStudentPNG } from "@app/assets";

export default function AddStudents() {
  
  let { id }: any = useParams()
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [addStudentDetails, showAddStudentDetails] = useState(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [deleteText, setDeleteText] = useState<string>("Remove");
  const { userInfo }: any = useContext(AuthContext);
  const userToken = userInfo && userInfo.sessionToken;
  const [studentsList, setStudentsList] = useState<any>([]);
  const [totalStudent, setTotalStudents] = useState<any>([]);
  const [studentPassword, setStudentPassword] = useState<any>({
    password: "",
    key: ""
  });
  const [showPasswordField, setShowPasswordField] = useState<boolean>(false);
  const [showPasswordButton, setShowPasswordButton] = useState<boolean>(true);
  const [spinner, setSpinner] = useState(false)
  const [classRoomDetails, showClassRoomDetails] = useState<any>()
  const [studentId, setStudentId] = useState()
  const [existStudent, showExistErr] = useState(false)
  const [noStudents, showNoStudents] = useState(false)
  const [removeEmptyInput, setRemoveEmptyInput] = useState(false)
  const [showToast, setShowToast] = React.useState(false);
  const [submitText, setSubmitText] = useState<string>("Add Google Students");
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  let history = useHistory();

  const { trigger, register, handleSubmit, errors, getValues }: any = useForm({});
  const [students, addStudents] = useState<any>([])
  const [maxStudentErr, showMaxStudentErr] = useState(false)
  const [addStudentPopup, showAddStudentPopup] = useState<boolean>(false)
  const [activeInput, showActiveInput] = useState<boolean>(false)
  const [maxStudents, setMaxStudents] = useState<any>()
  const [readMoreUnable, setReadMoreUnable] = useState(true)
  const location = useLocation();
  const pathData = location.pathname.split('/');
  const [returnData, setReturnData] = useState<boolean>(false)
  const [respErr, setRespErr] = useState<any>();
  const base64 = require('base-64')

  useEffect(() => {
    if (!userToken) {
      history.replace("/sign-in")
    }

    if ((userInfo && userInfo.userJson.userType === "parent" || userInfo && userInfo.userJson.userType === "student") && pathData[1] === "add-students") {
      history.replace('/pagenotfound')
    }
    if (userInfo && userInfo.userJson.userType === "educator") {
      getClassroomDetails()
    }
  }, [])

  function onSubmit(data: any) {
    // setDisableButton(true)
    showExistErr(false)
    if (existStudent) return;
    const params: any = {
      sessionToken: userInfo && userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
      classRoomId: id,
      studentDetails: JSON.stringify(data.students)
    }
    setSpinner(true)
    addStudent(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setSpinner(false);
          setShowSuccessPopUp(true)
          getClassroomDetails()
          addStudents([])
          showAddStudentPopup(false)
          showMaxStudentErr(false)
          let classes = JSON.parse(localStorage.getItem("classRooms") || '')
          let selectedClassRoom = classes.findIndex((classroom: any) => classroom.classRoomId == id);
          classes[selectedClassRoom] = response.classroomJson;
          localStorage.setItem("classRooms", JSON.stringify(classes))
        } else if (studentsList.length + students.length === maxStudents) {
          setToastMessage({
            type: "error",
            message: "Max no.of Students exceeded",
          });
          setShowToast(true);
          setSpinner(false);
        }
        else {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
  }



  const getClassroomDetails = () => {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo && userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
      classRoomId: id,
      studentsDataFlag: true
    });
    setSpinner(true)

    getClassroom(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setReturnData(true)
          showClassRoomDetails(response.allClassroomsDocs[0])  
          setStudentsList(response.allClassroomsDocs[0].studentData)
          setTotalStudents(response.allClassroomsDocs[0].noOfStudents)
          showNoStudents(response.allClassroomsDocs[0].studentData.length)
          let count = parseInt(response.allClassroomsDocs[0].noOfStudents)
          setMaxStudents(count)
          setSpinner(false)
          if (response.allClassroomsDocs[0].studentIds === '') {
            showActiveInput(true)
          }
          if (response.allClassroomsDocs[0].studentData.length === 0) {
            HandleAddStudent();
          }
        } else {
          setRespErr(resp.msg)
          setReturnData(false)
          setSpinner(false)
        }
      })
  }

  const deleteStudentFromClass = (studentId: any) => {
    if (studentsList.length === maxStudents) {
      showMaxStudentErr(false)
    }
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo && userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
      classRoomId: id,
      studentId: studentId
    });
    deleteStudent(params)
      .then((resp: any) => {
        const response = resp;
        if (response._responseStatus === 1) {
          setShowDelete(false)
          getClassroomDetails()
          let classes = JSON.parse(localStorage.getItem("classRooms") || '')
          let selectedClassRoom = classes.findIndex((classroom: any) => classroom.classRoomId == id);
          classes[selectedClassRoom] = response.classRoomJson;
          localStorage.setItem("classRooms", JSON.stringify(classes))

        }
      })
  }

  async function HandleAddStudent() {
    showMaxStudentErr(false)
    if (studentsList.length + students.length === maxStudents) {
      setToastMessage({
        type: "error",
        message: "Max no.of Students exceeded",
      });
      setShowToast(true);
      return
    }
    setReadMoreUnable(true)
    showAddStudentPopup(false)
    showAddStudentDetails(true);
    showActiveInput(true)
    totalStudents();
    const isvalid = await trigger();
    if (isvalid) {
      const randomid = Math.floor(Math.random() * 90000) + 10000;
      if (studentsList.length < maxStudents)
        addStudents([...students, { firstName: '', lastName: '', email: '', id: randomid }])
    }
  }
  const [formValues, setFormValues] = useState<any>([])
  function totalStudents() {
    let values = getValues()
    setFormValues(values.students)
  }

  function getConfirm(evt: any) {
    if (evt) {
      deleteStudentFromClass(studentId)
    }
  }
  const openConfirm = (userId: any) => {
    setStudentId(userId)
    setShowDelete(true)
  }
  const addRow = (evt: any, index: number, key: any) => {
    const values = [...students];
    values[index] = { ...values[index], ...evt }
    addStudents(values)
    // if (evt.target.namme === `students[${index}.firstName]` && evt.target.value.length > 0) {
    //   setReadMoreUnable(true)
    // } else if (evt.target.name === `students[${index}.lastName]` && evt.target.value.length > 0) {
    //   setReadMoreUnable(true)
    // } else if (evt.target.name === `students[${index}.email]` && emailPattern.test(evt.target.value)) {
    //   setReadMoreUnable(false)
    // }
    let formValues = getValues()
    if(key == "firstName" && formValues.students[index].firstName.length > 0) {
      formValues.students[index].email = generateUsername(formValues.students[index].firstName);
    }else if (key == "firstName" && formValues.students[index].firstName.length == 0) {
      formValues.students[index].email = "";
    }
    setFormValues(formValues.students);
  }

  function generateUsername(data: any) {
    const alphanumeric = ALPHA_NUMERIC;
    let randomUsername = "";
    for (let i = 0; i < USERNAME_CHAR_COUNT; i++) {
      const randomChar = alphanumeric[Math.floor(Math.random() * alphanumeric.length)];
      randomUsername += randomChar;
    }
    let childUsername = randomUsername;
    return childUsername;
  }

  function deleteInputRow(index: number) {
    let student: any = [...students]
    student.splice(index, 1);
    addStudents(student)
    setSubmitText('Add Google Students')
  }

  function showPassword(userId: string, index: number) {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      requestUserId: userId,
      classRoomId: classRoomDetails.classRoomId
    });
    setSpinner(true)
    showStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setStudentPassword({
            userId: response.userId,
            password: base64.decode(response.studentPassword),
            key: index
          });
          setShowPasswordField(true);
          setShowPasswordButton(false);
          setSpinner(false);
        }
        else {
          setToastMessage({
            type: "error",
            message: (response && response.msgCode) ? response.msg : "Failed to generate Password",
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
        setSpinner(false);
      })
  }

  function resetPassword(userId: string, index: number) {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      requestUserId: userId,
      classRoomId: classRoomDetails.classRoomId
    });
    setSpinner(true)
    resetStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setSpinner(false);
          setStudentPassword({
            userId: response.userId,
            password: base64.decode(response.studentPassword),
            key: index
          });
          setToastMessage({
            type: "success",
            message: "Student Password updated Successfully",
          });
          setShowToast(true);
          setShowPasswordField(true);
          setShowPasswordButton(false);
        }
        else {
          setToastMessage({
            type: "error",
            message: (response && response.msgCode) ? response.msg : "Failed to generate Password",
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      })
  }

  function hidePasswordLabel() {
    setShowPasswordField(false);
    setShowPasswordButton(true);
  }

  const handleRedirect = () => {
    if(userInfo && userInfo.userJson.googleAccountId != ''){
      if(readMoreUnable){
        setSubmitText('Submit');
        totalStudents();
      }else{
        setSubmitText('Add Google Students');
        history.replace('/google-students/' + classRoomDetails.googleClassroomId)
      }
    }
    else{
      setSubmitText('Submit');
      totalStudents();
    }
  }

  return (
    <>
      <Layout classRoomLayout={true}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* {returnData  && <> */}

          {returnData && studentsList && classRoomDetails && !addStudentPopup ?
            <h2 className="primary-header label-color text-center mb-1">{classRoomDetails.classRoomName}</h2> : ''
          }
          {<h3 className="primary-header fs-18 text-center mb-3">Add Student(s)</h3>}
          {returnData && studentsList && <h4 className="secondary-header mb-3">Students ({studentsList.length} of {totalStudent})</h4>}
          {/* {spinner &&
            <EmptyContainer className="without-pos">
              <Icon name="loader" />
              <DefaultMessage>Loading, please wait...</DefaultMessage>
            </EmptyContainer>
          } */}

          <StudentsTableWrapper>
            <table>
              <thead>
                <tr>
                  <th className="w-100">First Name</th>
                  <th className="w-100">Last Name</th>
                  <th className="w-130">Username</th>
                  <th className="w-130">Password</th>
                  <th className="w-60" >
                    <img src={AddStudentPNG} width="40px" style={{ float: "right" }} onClick={() => HandleAddStudent()}></img>
                  </th>
                </tr>
              </thead>
              <tbody>
                {studentsList && studentsList.map((student: any, index: any) => {
                  if (student) {
                    return (
                      <tr>
                        <td className="w-100">{student.firstName}</td>
                        <td className="w-100">{student.lastName}</td>
                        <td className="w-130">{student.email}</td>
                        <td className="w-130">{student.password}</td>
                        <td className="w-unset">
                          <span onClick={() => openConfirm(student.userId)}>
                            <RemoveIcon />
                          </span>
                        </td>
                      </tr>
                    )
                  }
                })}
                {spinner &&
                  <EmptyContainer>
                    <Icon name="loader" />
                    <DefaultMessage>Loading, please wait...</DefaultMessage>
                  </EmptyContainer>
                }
                {returnData && studentsList.length === 0 && students.length === 0 && spinner === false &&
                  <EmptyContainer>
                    <DefaultMessage className="mb-2 small-font">No Students added yet in the Classroom</DefaultMessage>
                  </EmptyContainer>
                }
                {students.map((student: any, index: number) => {
                  return (
                    <tr className="has-inputs" key={student.id}>
                      <td>
                        <Input
                          placeholder="First Name"
                          onBlur={(e) => addRow(e, index, 'firstName')}
                          name={`students[${index}.firstName]`}
                          register={register({
                            required: true,
                            validate: (value: any) => {
                              return value.trim().length > 0;
                            },
                          })}
                          autoFocus={true}
                          className="m-0"
                        // defaultValue={student.firstName}
                        />
                        {formValues && formValues[index] && !formValues[index]["firstName"] && (
                          <Error>Please enter First Name</Error>
                        )}

                      </td>
                      <td>
                        <Input
                          placeholder="Last Name"
                          name={`students[${index}.lastName]`}
                          // defaultValue={student.lastName}
                          onChange={(e) => addRow(e, index, 'lastName')}
                          register={register({
                            required: true,
                            validate: (value: any) => {
                              return value.trim().length > 0;
                            },
                          })}
                          className="m-0"
                        />
                        {formValues && formValues[index] && !formValues[index]["lastName"] && (
                          <Error>Please enter Last Name</Error>
                        )}
                      </td>
                      <td>
                        <Input
                          type="email"
                          placeholder="Username"
                          name={`students[${index}.email]`}
                          // name="email"
                          value={(formValues && formValues[index] && formValues[index]["email"])}
                          register={register({
                            required: true,
                          })}
                          className="m-0"
                          error={(formValues && formValues[index] && !formValues[index]["email"] &&
                            "Username can not be empty")
                          }
                        />


                      </td>
                      <td className="w-130"></td>
                      <td className="w-60" onClick={() => deleteInputRow(index)}>
                        <RemoveIcon />
                      </td>
                    </tr>

                  )
                })}

              </tbody>
            </table>
            {maxStudentErr && <p>Max no.of students exceded</p>}
          </StudentsTableWrapper>
          {userInfo && userInfo.userJson.googleAccountId != '' && classRoomDetails?.googleClassroomId !== undefined && classRoomDetails?.googleClassroomId != "false" &&
          <button type="button" disabled={!returnData} className="anchor-tag d-block text-center mx-auto mt-3 mb-2"
            onClick={() => history.replace('/google-students/' + classRoomDetails.googleClassroomId)}>
            + Add Google Students
          </button>}
          <><ButtonContainer>
            <Button
              type="submit"
              variant="newsecondary"
              size="large"
              width="100%"
              disabled={!returnData}
              // onClick={() => setShowSuccessPopUp(true)}
              onClick={() => totalStudents()}
              // onClick={handleRedirect}
            >
              Submit
            </Button>
          </ButtonContainer>
            <Button type="button" variant="bordered" size="large" width={"100%"} onClick={() => history.replace("/classrooms")}>Cancel</Button>
          </>

        </form>

        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          title=""
          onClose={() => setShowToast(false)}
        />
      </Layout>

      {
        showDelete &&
        <DeleteChildDialog
          // dialogTitle="Confirm Removal"
          noTitle={true}
          confirmationText="Are you sure you want to remove the student account from the classroom ?"
          confirmationMsg="The student account will be removed from the classroom and you can add again at anytime."
          deleteText={deleteText}
          onClose={() => setShowDelete(false)}
          deleteChild={getConfirm}
        />
      }
      {
        showSuccessPopUp &&
        <PopUpWrapper>
          <PopUpContainer>
            <Icon name="signsuccess" />
            <span className="close-icon" onClick={() => setShowSuccessPopUp(false)}>
              <Icon name="close" />
            </span>
            <PopUpTitle>Student(s) added successfully!</PopUpTitle>
            <PopUpSubTitle>Login to access and explore the KazooBadoo.</PopUpSubTitle>
            <PopUpText>
              <Button
                variant="newsecondary"
                type="button"
                width="100%"
                onClick={() => setShowSuccessPopUp(false)}
              >
                Continue
              </Button>

            </PopUpText>
          </PopUpContainer>
        </PopUpWrapper>

        // setShowSuccessPopUp={setShowSuccessPopUp}
        // title={successMessage.title}
        // subtitle={successMessage.subtitle}
        // text={successMessage.text}
        // click={successMessage.click} 


      }

    </>
  );
}
